import { FormEvent, useState } from 'react';
import './style.css';
import AuthService from '../../api/authService';
import toast from 'react-hot-toast';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FloatLabel } from 'primereact/floatlabel';
import { Password } from 'primereact/password';
import { Card } from 'primereact/card';

interface LoginPageProps {
  callback: (result: boolean) => void;
}

const LoginPage = ({ callback }: LoginPageProps) => {
  const [fetching, setFetching] = useState<boolean>();
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const handleAuth = async (event: FormEvent) => {
    event.preventDefault();

    if (username.length === 0 || password.length === 0) {
      return;
    }

    setFetching(true);
    const result = await AuthService.login(username, password);
    setFetching(false);

    if (!result) {
      toast.error('Login failed');
      setUsername('');
      setPassword('');
    }

    callback(result);
  };

  return (
    <div className="page-login">
      <Card className="login-card">
        <div className="login-header">
          <img
            src="/images/logo.png"
            alt="Logo"
            className="login-logo"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
          <h1 className="login-title">Word Atlas</h1>
        </div>
        <form onSubmit={handleAuth}>
          <FloatLabel>
            <InputText
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <label htmlFor="username">Username</label>
          </FloatLabel>

          <FloatLabel>
            <Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              feedback={false}
            />
            <label htmlFor="password">Password</label>
          </FloatLabel>

          <Button disabled={fetching} label="Login" severity="success" />
        </form>
      </Card>
    </div>
  );
};

export default LoginPage;
